import { api } from '../api';

const getVehicleDetailList = async ({ customerId, id, providerType }) => {
  const response = await api({
    url: `VehicleDetails/GetVehicleListDetail`,
    method: 'GET',
    headers: {
      'x-skip-loader': true,
    },
    params: {
      customerId: customerId,
      VehicleId: id,
      VouId: providerType,
    },
  });
  return response.data;
};

const getVehicleActivationCode = async ({ customerId, vehicleId }) => {
  const response = await api({
    url: `Vehicles/GetActivationCode`,
    method: 'GET',
    headers: {
      'x-skip-loader': true,
    },
    params: {
      customerId,
      VehicleId: vehicleId,
    },
  });
  return response.data;
};

const disconnectFromAccount = async ({ customerId, plate, vouId }) => {
  const response = await api({
    url: `Vehicles/disconnectFromAccount`,
    method: 'POST',
    headers: {
      'x-skip-loader': true,
    },
    data: {
      customerId,
      plate,
      vouId,
    },
  });
  return response.data;
};

const createActivationCode = async ({ customerId, vehicleId }) => {
  const response = await api({
    url: `Vehicles/createActivationCode`,
    method: 'POST',
    headers: {
      'x-skip-loader': true,
    },
    data: {
      customerId,
      vehicleId,
    },
  });
  return response.data;
};

const getUpdateVehicleLimits = async ({ limitedValue }) => {
  const response = await api({
    url: `VehicleDetails/UpdateVehicleLimits`,
    method: 'PUT',
    headers: {
      'x-skip-loader': true,
    },
    data: limitedValue,
  });
  return response.data;
};

const postVehicleDeviceTypes = async ({ vehicles }) => {
  const response = await api({
    url: `VehicleDeviceTypes/createDeviceVehicles`,
    method: 'POST',
    headers: {
      'x-skip-loader': true,
    },
    data: vehicles,
  });
  return response.data;
};

const postUpdateVehicle = async ({ request }) => {
  const response = await api({
    url: `Vehicles/updateVehicle`,
    method: 'POST',
    headers: {
      'x-skip-loader': true,
    },
    data: request,
  });
  return response.data;
};

const postUpdateVehicleDriver = async ({ request }) => {
  const response = await api({
    url: `Vehicles/updateVehicleDriver`,
    method: 'POST',
    headers: {
      'x-skip-loader': true,
    },
    data: request,
  });
  return response.data;
};

const getUpdateVehicleDisable = async ({ request }) => {
  const response = await api({
    url: `Vehicles/UpdateVehicleDisable`,
    method: 'PUT',
    headers: {
      'x-skip-loader': true,
    },
    data: request,
  });
  return response.data;
};

const postVehicleDeviceCancelRenew = async ({ request }) => {
  const response = await api({
    url: `VehicleDeviceTypes/cancelVehicleDevice`,
    method: 'POST',
    headers: {
      'x-skip-loader': true,
    },
    data: request,
  });
  return response.data;
};

const deletePlateAndAllDevices = async ({ request }) => {
  const response = await api({
    url: `Vehicles/DeletePlateAndAllDevices`,
    method: 'DELETE',
    headers: {
      'x-skip-loader': true,
    },
    data: request,
  });
  return response.data;
};

const permanentlyCancelVehicleDevice = async ({ request }) => {
  const response = await api({
    url: `VehicleDeviceTypes/PermanentlyCancelVehicleDevice`,
    method: 'POST',
    headers: {
      'x-skip-loader': true,
    },
    data: request,
  });
  return response.data;
};

const vehicleManagementDetailServices = {
  getVehicleDetailList,
  getUpdateVehicleLimits,
  postVehicleDeviceTypes,
  postUpdateVehicle,
  postUpdateVehicleDriver,
  getUpdateVehicleDisable,
  postVehicleDeviceCancelRenew,
  deletePlateAndAllDevices,
  permanentlyCancelVehicleDevice,
  getVehicleActivationCode,
  createActivationCode,
  disconnectFromAccount,
};

export default vehicleManagementDetailServices;
